export class Organization {
    id: number = 0;
    name: string = '';
    organizationTeamId?: string = '';

    constructor(data?: any) {
        this.id = data?.id || 0;
        this.name = data?.name || '';
        this.organizationTeamId = data?.organizationTeamId || '';
    }
}

export class OrganizationForSelect {
    id: number = 0;
    name: string = '';

    constructor(data?: any) {
        this.id = data?.id || 0;
        this.name = data?.name || '';
    }
}

export class OrganizationMultiSelect {
    id: number = 0;
    name: string = '';
    checked: boolean = false;

    constructor(data?: any) {
        this.id = data?.id || 0;
        this.name = (data?.organizationTeamId ?? data?.name) || '';
        this.checked = false;
    }
}